class WebSocketManager {
    static instance;
    connections = new Map();
    listeners = new Map();
    constructor(){}
    static getInstance() {
        if (!this.instance) this.instance = new WebSocketManager();
        return this.instance;
    }
    getConnection(key) {
        return this.connections.get(key);
    }
    addMessageListener(key, listener) {
        if (!this.listeners.has(key)) this.listeners.set(key, new Set());
        this.listeners.get(key).add(listener);
    }
    removeMessageListener(key, listener) {
        this.listeners.get(key)?.delete(listener);
    }
    createConnection(key, url) {
        if (!this.connections.has(key)) {
            const ws = new WebSocket(url);
            ws.onmessage = (event)=>{
                this.listeners.get(key)?.forEach((listener)=>{
                    try {
                        const data = JSON.parse(event.data);
                        listener(data);
                    } catch  {}
                });
            };
            this.connections.set(key, ws);
            return ws;
        }
        return this.connections.get(key);
    }
    closeConnection(key) {
        const ws = this.connections.get(key);
        if (ws) {
            ws.close();
            this.connections.delete(key);
            this.listeners.delete(key);
        }
    }
}
export { WebSocketManager };
